<template>
  <div style="background: #F1C864;min-height: 100%;">
    <navigation class="header" @click="
      $report({
        id: 50056
    })"
    ></navigation>
    <div class="page">
      <!-- <div class="back" :style="{marginTop: statusBarHeight + 'px'}">
                <div class="click-area">
                    <svg @click="back" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 18 30">
                        <path fill-rule="evenodd" d="M6.600,15.000 L7.600,14.000 L17.400,4.200 C18.174,3.426 18.174,2.174 17.400,1.399 L17.400,1.399 C16.626,0.626 15.373,0.626 14.599,1.399 L0.001,15.999 L0.001,15.999 L14.599,30.599 C15.373,31.374 16.626,31.374 17.400,30.599 L17.400,30.599 C18.174,29.825 18.174,28.574 17.400,27.799 L7.600,18.000 L6.600,17.000 "></path>
                    </svg>
                </div>
            </div> -->
      <header>
        <img
          class="logo"
          src="../../user/images/logo.png"
          srcset="
                        ../../user/images/logo@2x.png 2x,
                        ../../user/images/logo@3x.png 3x
                    "
        />
        <div
          class="rule-button"
          @click="goActivityRule"
          v-stat="{ id: 50057, args: { step: status } }"
        >
          <span class="rule-button-icon">?</span>活动规则
        </div>
      </header>

      <section>
        <div class="paragragh" v-if="[0].includes(status)">
          - 最长30天免息券任性领 -
        </div>
        <!-- <div class="paragragh" v-else-if="status === 1">
                    {{ couponExpire | date('YYYY/MM/DD') }}前完成借款有效
                </div> -->
        <!-- <div class="paragragh" v-else-if="status === 2"></div> -->
        <div class="paragragh" v-else-if="status === 3">
          很遗憾，本次活动已结束
        </div>
        <div class="paragragh" v-else>
        </div>
        <div class="main" v-if="status === 0">
          <img
            class="main-mao"
            src="./images/img_mao01.png"
          />
          <div class="redpacket-list">
            <div class="redpacket-item" v-for="item in redpacketList" :key="item">
              <div class="redpacket-content">{{item}}天<br>免息</div>
            </div>
          </div>
          <div
            class="button has-tag"
            @click="startGoodLuck"
            v-stat="{ id: 50055 }"
          >开启好运</div>
        </div>
        <template v-else-if="status === 1">
          <div class="main" v-if="!placeholder">
            <img
              class="main-mao mao-02"
              src="./images/img_mao02.png"
            />
            <div class="lottery-content">
              <p class="content">您已获得{{day}}天免息红包</p>
              <p class="expire">{{couponExpire | date('YYYY/MM/DD')}}前完成借款有效</p>
              <div class="coupon-btn"
                   @click="
                     navigateTo({
                       h5: '/quan/list',
                       voucher:true
                   })"
                   v-stat="{ id: 50060 }"
              >查看券包</div>
            </div>
            <div
              class="button"
              @click="navigateTo(nextNode)"
              v-stat="{ id: 50059 }"
            >申请提现</div>
          </div>
          <div class="placeholder" v-else></div>
        </template>
        <div class="main" v-else-if="status === 2">
          <img
            class="main-mao mao-02"
            src="./images/img_mao02.png"
          />
          <div class="lottery-content">
            <p class="content">您已获得{{day}}天免息红包</p>
            <p class="expire">可在【我的券包】查看</p>
          </div>
          <div
            class="button"
            @click="
              navigateTo({
                h5: ['USED', 'CREDIT_LOCKED', 'LOAN_LOCKED','TIMEOUT'].includes(couponStatus) ? '/quan/history' : '/quan/list',
                voucher:true
            })"
            v-stat="{ id: 50062 }"
          >查看券包</div>
        </div>
        <div class="main" v-else-if="status === 3">
          <img
            class="main-mao mao-02"
            src="./images/img_mao02.png"
          />
          <div class="lottery-content">
            <p class="wx-tips">关注天美贷公众号，及早获取更多福利</p>
            <img src="./images/img_0@2x.png" title="微信" class="wx-img" @click="copy"/>
          </div>
        </div>
        <div class="raiders" v-if="status !== 3">
          <img
            src="./images/img_gonglue.png"
            srcset="
                            ./images/img_gonglue@2x.png 2x,
                            ./images/img_gonglue@3x.png 3x
                        "
          />
          <img src="./images/img_0@2x.png" title="微信" class="wx-img" @click="copy"/>
        </div>
      </section>
      <footer style="color: #BA8536;">活动所有解释权归天美贷所有</footer>
      <nd-dialog
        v-model="dialog"
        :footer="false"
        :closeBtn="true"
        @close="closeDialog"
      >
        <div class="dialog-content" slot="custom">
          <p>
            抱歉，您当前无法提现！
          </p>
          <p>
            您当前处于封禁期，<br />请于{{
              lockingDay | date('YYYY/MM/DD')
            }}重新发起!
          </p>
          <div
            class="button"
            @click="navigateTo({...nextNode,voucher:true})"
            v-stat="{ id: 50064 }"
          >
            查看详情
          </div>
        </div>
      </nd-dialog>
      <turntable
        ref="turntable"
        :day="day"
        @animationEnd="animationEnd"
      ></turntable>
    </div>
  </div>
</template>
<script>
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { mapState, mapActions } from 'vuex'
import { copyToClipbord } from '@/assets/utils'
import { judgeClientSystem } from '../../../assets/utils'
import Turntable from './components/turntable'

const redpacketList = [7, 15, 30]

export default {
  name: 'activity-relending',
  customReadyNotify: true,
  components: { Turntable },
  data () {
    return {
      day: 0,
      status: 3, // 0->未抽奖 1->抽取红包15日内未成功借款 2->抽取红包15日内已激活/未激活已失效 3->活动过期未抽奖
      qualification: false,
      activeType: 'PERSON_REPEAT_LOAN',
      couponStatus: 'PRE_PROVIDE',
      nextStep: null,
      activeId: 0,
      couponExpire: null,
      dialog: false, // 提现封禁期
      placeholder: false,
      couponId: null,
      redpacketList,
      redPacketPopup: true,
      activeStartTime: 0,
      activeEndTime: 0,
      relationId: null
    }
  },
  computed: {
    ...mapState('user', {
      creditStatus: (state) => state.quotaInfo.creditStatus,
      lockingDay: (state) => state.quotaInfo.lockingDay,
      loanStatus: (state) => state.quotaInfo.loanStatus
    }),
    ...mapState({
      statusBarHeight: state => state.statusBarHeight - 15
    }), 
    nextNode () {
      switch (this.nextStep) {
        case 'OCR':
          return { h5: '/authentication/id', native: 'ocr' }
        case 'INFO':
          return { h5: '/authentication/base', native: 'basic_info' }
        case 'CREDIT':
          return {
            h5: '/authentication/base',
            native: 'basic_info'
          }
        case 'CREDIT_REVIEW':
        case 'CREDIT_LOCKED':
          return {
            h5: `/authentication/result?applyNo=${this.relationId}`
          }
        case 'LOAN_LOCKED':
        case 'LOAN_REFUSED':
        case 'LOANING':
        case 'LOAN_REVIEW':
        case 'LOAN_WAIT_VIP':
          return {
            h5: `/withdraw/result?loanApplyNo=${this.relationId}`
          }
        case 'LOAN':
        case 'LOAN_PASSED':
          return {
            h5: `/withdraw/index`, native: 'withdraw'
          }
        default:
          return { h5: '/authentication/id', native: 'ocr' }
      }
    }
  },
  async created () {
    await this.getActiveDetail()
    await this.getLimitX({ loanPlatform: 'TMD' })
    // if (!this.couponId && this.qualification) await this.receiveCoupon({ activeId: this.activeId })
    if (this.couponId) await this.getCouponDetail()
    let screen = ''
    switch (this.status) {
      case 0:
        screen = 'page_no_extraction'
        break
      case 1:
        screen = 'page_unactivated'
        break
      case 2:
        screen = 'page_failure'
        break
      case 3:
        screen = 'page_no_lottery'
        break
      default:
        break
    }
    this.$report({
      id: 10002,
      args: {
        screen,
        visible: 1
      }
    })
    this.$once('hook:beforeDestroy', () => {
      this.$report({
        id: 10002,
        args: {
          screen,
          visible: 0
        }
      })
    })
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('user', ['getLimitX']),

    ...mapActions('activities', [
      'qualificationCouponX',
      'couponDetailX',
      'activeCouponX',
      'receiveCoupon'
    ]),
    // 拷贝微信
    copy () {
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
      this.$report({
        id: 50058,
        args: {
          step: status
        }
      })
    },
    animationEnd () {
      this.status = 1
      this.$message('已放入券包，可随时查看')
      this.$report({
        id: 50061,
        args: {
          visible: 0
        }
      })
    },
    back () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.back()
      }
    },
    goActivityRule () {
      this.$router.push(`/activities/relending/rule?start=${this.activeStartTime}&end=${this.activeEndTime}`)
    },
    async getCouponDetail () {
      const res = await this.couponDetailX({
        couponRecordId: this.couponId
      })
      this.couponDetail = res.data || {}
      this.couponStatus = this.couponDetail.status
      this.day = this.couponDetail.discountValue
      this.couponExpire = this.couponDetail.endTime

      if (this.couponStatus === 'PRE_PROVIDE' || !this.couponStatus) {
        this.status = 1
      } else {
        this.status = 2
      }
    },
    async getActiveDetail () {
      const res = await this.qualificationCouponX({
        activeType: this.activeType
      })
      if (res.data[0]) {
        this.qualification = res.data[0].qualification
        this.couponId = res.data[0].couponRecordId
        this.nextStep = res.data[0].nextStep
        this.activeId = res.data[0].couponActiveId
        this.activeStartTime = res.data[0].activeStartTime
        this.activeEndTime = res.data[0].activeEndTime
        this.relationId = res.data[0].relationId
        if (this.qualification) this.status = 0
        // if (['OCR', 'INFO', 'CREDIT', 'CREDIT_LOCKED', 'LOAN_LOCKED', 'LOCKED', 'CREDIT_REVIEW', 'UNCREDIT', 'LOAN'].includes(this.nextStep)) {
        //     this.status = 0
        // }
      }
    },
    routerTo (path) {
      this.$router.push(path)
    },
    navigateTo (path) {
      // if (path.native === 'withdraw') {
      //     if (this.nextStep === 'LOANING' || this.nextStep === 'LOAN_REVIEW') return this.$message('提现审核中，暂不能提现')
      //     if (this.creditStatus === 'LOAN_REFUSED' || this.nextStep === 'LOAN_LOCKED') {
      //         // return this.$message('提现封禁中，暂不能提现')
      //         this.dialog = true
      //         this.$report({
      //             id: 50063,
      //             args: {
      //                 visible: 1
      //             }
      //         })
      //         return
      //     }
      //     if (this.nextStep === 'CREDIT_REVIEW') return this.$message('授信审核中，暂不能提现')
      //     if (this.nextStep === 'CREDIT_LOCKED') return this.$message('授信封禁中，暂不能提现')
      // }
      if (hasNativeMethod('navigateTo') && !!path.native && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true })
      } else {
        this.$router.push(path.h5)
      }
    },
    async startGoodLuck () {
      // 如果有资格，但是没有优惠券的id，表示未领取优惠券，请求接口去领取优惠券
      if (this.qualification && !this.couponId) {
        const res = await this.receiveCoupon({ activeId: this.activeId })
        if (res.success) {
          await this.getActiveDetail()
          await this.getLimitX({ loanPlatform: 'TMD' })
          if (this.couponId) await this.getCouponDetail()
        }
      } 
      this.$refs.turntable.open()
      this.$report({
        id: 50061,
        args: {
          visible: 1
        }
      })
    },
    closeDialog () {
      this.dialog = false
      this.$report({
        id: 50063,
        args: {
          visible: 0
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.dialog-content {
    width: 620px;
    height: 450px;
    padding: 0 70px;
    background: rgba(255, 255, 255, 1);
    border-radius: 30px;
    overflow: hidden;
    text-align: center;
    p:nth-child(2) {
        padding-bottom: 66px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 42px;
    }
    .dialog2-img{
        margin: 20px 0 38px;
        width: 500px;
        height: 152px;
    }
    p:nth-child(1) {
        font-size: 36px;
        padding:70px 0 60px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 50px;
    }
    .button {
        width: 440px;
        height: 80px;
        line-height: 80px;
        margin:  auto ;
        background: linear-gradient(
            90deg,
            rgba(255, 51, 51, 1) 0%,
            rgba(255, 95, 52, 1) 100%
        );
        border-radius: 40px;
        font-size: 32px;
        color: rgba(255, 255, 255, 1);
    }
}

@keyframes bounceUpDown {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-30px);
    }
    100% {
        transform: translateY(0);
    }
}

img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.page {
    background: url('./images/bg_01@2x.png') center top no-repeat #F1C864;
    background-size: 100%;
    color: #fff;
    font-size: 28px;
    overflow: hidden;
    .back {
        padding: 0 30px 0 0;
        height: 110px;
        justify-content: space-between;
        box-sizing: content-box;
        align-items: center;
        position: relative;
        display: flex;
        z-index: 1000;
        font-size: 36px;
        font-family: PingFangSC-Medium,PingFang SC;
        font-weight: 500;
        color: @fc1;
        background-color: #fff;
        .click-area {
            width: 88px;
            height: 76px;
            overflow: hidden;
            > svg {
                display: block;
                margin: 22px auto;
                width: 48px;
                height: 36px;
            }
        }
    }
    header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        margin-top: 51px;
        .logo {
            width: 70px;
            height: 70px;
            margin-left: 35px;
        }
        .rule-button {
            display: flex;
            align-items: center;
            font-size: 28px;
            color: rgba(255, 255, 255, 1);
            > span {
                width: 32px;
                height: 32px;
                line-height: 32px;
                margin-right: 5px;
                background-color: rgba(255, 255, 255, 1);
                color: #8ab4f6;
                font-weight: 600;
                border-radius: 50%;
                text-align: center;
            }
        }
    }
    section {
        .title {
            width: 100%;
            margin-top: 37px;
            padding: 0 31px;
        }
        .paragragh {
            margin:220px auto 0;
            height: 50px;
            line-height: 50px;
            font-size: 28px;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            &.bg {
                width: 490px;
                background: rgba(253, 111, 42, 1);
                border-radius: 25px;
            }
        }
        .turntable {
            width: 100%;
            height: 812px;
            animation: toggle 0.5s linear infinite;
            background-size: 100% 100%;
        }
        .placeholder {
            width: 100%;
            height: 812px;
        }
        .main {
            position: relative;
            width: 100%;
            height: 870px;
            overflow: hidden;
            .main-mao {
                width: 260px;
                height: 215px;
                margin: 20px auto 0;
                &.mao-02{
                    width: 195px;
                    height: 185px;
                    margin-top: 24px;
                }
            }
            .redpacket-list {
                display: flex;
                justify-content: space-between;
                width: 600px;
                margin: 84px auto 0;
                .redpacket-item {
                    width: 200px;
                    height: 271px;
                    background: url(./images/img_dizuo@2x.png) center no-repeat;
                    background-size: 100%;
                    padding-top: 18px;
                    .redpacket-content {
                        width: 140px;
                        height: 200px;
                        background: url(./images/img_card@2x.png) center no-repeat;
                        background-size: 100%;
                        margin: 0 auto;
                        font-size: 30px;
                        color: #ffffff;
                        text-align: center;
                        padding-top: 58px;
                        animation: bounceUpDown 1.5s linear infinite;
                    }
                    &:nth-child(1) .redpacket-content {
                        animation-delay: 0s;
                    }
                    &:nth-child(2) .redpacket-content {
                        animation-delay: .5s;
                    }
                    &:nth-child(3) .redpacket-content {
                        animation-delay: 1s;
                    }
                }
            }
            .lottery-content{
                text-align: center;
                margin-top: 80px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                height: 262px;
                .content{
                    font-size: 36px;
                    color: #FF4633;
                }
                .expire{
                    font-size: 24px;
                    color: #666666;
                }
                .coupon-btn{
                    font-size: 32px;
                    color: #FF4633;
                    border: 2px solid #FF4633;
                    border-radius: 27px;
                    width: 200px;
                    margin-top: 29px;
                }
                .wx-tips{
                    color: #666666;
                    font-size: 28px;
                    text-align: left;
                    width: 100%;
                    padding-left: 92px;
                }
                .wx-img{
                    width: 570px;
                    height: 88px;
                    margin-top: 11px;
                }
            }
            .button {
                position: absolute;
                top: 639px;
                left: 50%;
                transform: translate3d(-50%, 0, 0);
                width: 477px;
                height: 139px;
                line-height: 139px;
                background: url(./images/btn_0@2x.png) center no-repeat;
                background-size: 100%;
                font-size: 42px;
                color: #B67011;
                font-weight: bold;
                text-align: center;
                line-height: 110px;
                &.has-tag::after{
                    content: "100%中奖";
                    position: absolute;
                    right: 31px;
                    top: 12px;
                    width: 110px;
                    height: 35px;
                    line-height: 35px;
                    font-size: 20px;
                    text-align: center;
                    color: #ffffff;
                    background-color: #FF4633;
                    border-radius: 92px 92px 92px 0;
                }
            }
        }
        .raiders {
            width: 717px;
            height: 687px;
            margin: 28px auto 0;
            .wx-img{
                width: 570px;
                height: 88px;
                margin: -164px auto 0;
            }
        }
    }
    footer {
        font-size: 24px;
        color: #fff;
        text-align: center;
        margin-top: 76px;
        margin-bottom: 57px;
    }
}

</style>
